import { motion } from "framer-motion";
import { urlFor } from "../../client";
import AppWrapper from "../../Wrapper/AppWrapper";
import MotionWrap from "../../Wrapper/MotionWrapper";
import './About.scss';

const About = ({ data }) => {


  return (
    <>
      <h2 className="head-text">
        I Know That Good Design Powers<span> Great Apps, </span> <br />and Great Apps <span>Drive Success</span>
      </h2>

      <div className="app__profiles">
        {

          data.map((about, index) => (
            <motion.div
              whileInView={{ opacity: 1 }}
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.5, type: "tween" }}
              className="app__profile-item"
              key={about.title + index}
            >
              <img
                src={urlFor(about.imgUrl).width(800).format('webp').url()}
                fetchpriority="high"
                alt={`knowledgeable developer ${about.title}` || "knowledgeable developer"}
              />

              <h3 className="bold-text" style={{ marginTop: 20, }}>
                {about.title}
              </h3>

              <p className="p-text" style={{ marginTop: 20, }}>
                {about.description}
              </p>

            </motion.div>
          ))}
      </div>

    </>
  )
}

export default AppWrapper(MotionWrap(About, 'app__about'), 'about', 'app__whitebg');